var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IconButton',{attrs:{"variant":"success","title":"Download CSV","icon":"file-csv"},on:{"click":function($event){return _vm.download()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }